import { above, below, between, media } from "core-web/utils/mediaqueries";
//@todo should we have default colors, spaces config stuff also in core if theme
// is missing..or will this never happen?
import { breakpoints } from "theme/config/breakpoints";
import colors from "theme/config/colors";
import easings from "theme/config/easings";
import fonts from "theme/config/fontFamilies";
import fontSizes from "theme/config/fontSizes";
import fontWeights from "theme/config/fontWeights";
import spaces from "theme/config/spaces";
import speed from "theme/config/speed";
import transitions from "theme/config/transitions";
import variables from "theme/config/variables";

const appTheme = () => ({
    above,
    below,
    between,
    breakpoints,
    media,
    colors,
    easings,
    fonts,
    fontSizes,
    fontWeights,
    space: spaces,
    speed,
    transitions,
    variables,
});

export type AppTheme = ReturnType<typeof appTheme>;

export default appTheme;

// This is an example use of the hook.
// hooks.subscribe(SiteEvents.MOUNTED, () => {
//     return new Promise(resolve => {
//         resolve();
//     });
// });
